import { useEffect } from "react";
import { Form, Input, Flex, Select, InputNumber, Button } from "antd";

import StyledModal from "./style";

import {
  cleanPhoneMask,
  selectValue,
  setPhoneMask,
} from "../../../../../../utils/helper/general";
import { isOrganizationBx } from "../../../../../../utils/helper/specialized";

const ModalCompanyUserSettings = ({
  companyName,
  companyType,
  loading,
  onCancel,
  onFinish,
  open,
  userData,
  userTypes,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open || !form) return;

    userData ? form.setFieldsValue(userData) : form.resetFields();
  }, [open]);

  const isOptionUserTypeEnabled = ({ companyType, userType }) => {
    if (!companyType || !userType) return false;

    if (companyType === "ProPortal") return userType === "ProPortalAdvisor";

    if (companyType === "Affiliate") return userType === "AffiliateAdvisor";

    if (companyType === "ProPortalAffiliate")
      return userType === "ProPortalAdvisor" || userType === "AffiliateAdvisor";

    return userType.includes("LevelWealth");
  };

  const options = userTypes
    ?.map(it => ({
      hidden: !isOptionUserTypeEnabled({
        userType: it.type,
        companyType,
      }),
      label: isOrganizationBx(companyName)
        ? it.displayName.replace("LevelWealth ", "")
        : it.displayName,
      value: it.type,
    }))
    ?.filter(it => !it.hidden);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formCompanyUserSettings"
            htmlType="submit"
            shape="round"
            type="primary"
          >
            {userData ? "Update" : "Add User"}
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title={userData ? "User Information" : "Add User"}
      width={647}
    >
      <Form
        id="formCompanyUserSettings"
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Flex gap={16}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Flex>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: "email",
            },
          ]}
        >
          <Input disabled={userData} size="large" />
        </Form.Item>

        <Flex gap={17}>
          <Form.Item
            label="Phone"
            name="phone"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber
              controls={false}
              formatter={setPhoneMask}
              onClick={selectValue}
              parser={cleanPhoneMask}
              size="large"
            />
          </Form.Item>
          <Form.Item label="Phone alt" name="phoneAlt">
            <InputNumber
              controls={false}
              formatter={setPhoneMask}
              onClick={selectValue}
              parser={cleanPhoneMask}
              size="large"
            />
          </Form.Item>
        </Flex>

        <Form.Item
          label="User Type"
          name="type"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select disabled={userData} options={options} size="large" />
        </Form.Item>
      </Form>
    </StyledModal>
  );
};

export default ModalCompanyUserSettings;
